const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth/login-complete.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { loginCompletionSearchSchema } from '@/features/authentication/types/accountAccess';
import { LOGIN_ROUTE, waitForAuth } from '@/shared/lib/authSession';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/login-complete')({
  validateSearch: loginCompletionSearchSchema,
  beforeLoad: async () => {
    const user = await waitForAuth();
    if (!user) throw redirect({
      to: LOGIN_ROUTE
    });
    return {
      loginUser: user
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});